export default {"src":"https://cp-landing.wukongedu.net/_next/static/media/logo-english.ea214fa7.svg","height":50,"width":142,"blurWidth":0,"blurHeight":0};